import axios from 'axios'

export const initial = {
  namespaced: true,
  state: {
    detail: {}
  },

  mutations: {
    setDetail(state, detail) {
      state.detail = detail
    },
    clean(state) {
      state.detail.user_id = null
      $cookies.remove('wegow.auth_token')
      $cookies.remove('wegow.access_token')
      $cookies.remove('wegow.refresh_token')
    }
  },

  actions: {
    async detail({ commit }, payload) {
      await axios
        .get('/initial/')
        .then(res => {
          commit('setDetail', res.data)
        })
        .catch(res => {
          if (res.status !== 401) {
            if (typeof window !== 'undefined') {
              if (typeof CustomEvent === 'function') {
                var event = new CustomEvent('showError', {
                  detail: {
                    textI18N: 'error.title',
                    error: res
                  }
                })
                window.dispatchEvent(event)
              }
            }
          }
        })
    },
    clean({ commit }) {
      commit('clean')
    }
  }
}
